import React, { useState } from 'react';
import styles from './resume.module.css';
import gStyles from '../../../global.module.css';
import Colors from '../../../const/colors';
import { ResumeData } from '../../../const/resume';
import { PRINT_FULL_RESUME } from '../../../const/env';
import ColoredLine from '../../../components/coloredLine';
import ResumeItems from './resumeItems';
import MyButton from '../../../components/buttons/button';
import ReactGA from 'react-ga4';

export default function ResumeContent() {
  const {
    maskBackground,
    resumeFilterButtons,
    smallerButton,
    activeStyleFilter,
    magentaButton,
    noPrint,
    qr,
    printOnly,
    softSkillBubble,
    softSkillContainer,
    printResumeSection,
    resumeIntro,
    resumeIntroPrint,
  } = styles;
  const resumeIntroText =
    'I am a software engineer by instinct, a problem solver by nature, and an innovator in all I do. I build teams, systems, and momentum. With 10+ years of leading international software organizations across engineering, QA, design, product, and delivery, I have driven software strategy for everything from SaaS startups to enterprise corporations, turning technical complexity into measurable business leverage. I specialize in AI and agentic workflows that unlock efficiency, output, and performance gains, and I consistently identify high-impact opportunities that save companies millions while moving products forward.';
  const getResumeDataForFilter = (filterType = 'all') => {
    const experience = ResumeData.experience
      .filter((item) => {
        if (filterType === 'education') return item.edBool === true;
        if (filterType === 'development') return item.devBool === true;
        return true;
      })
      .map((item) => ({
        ...item,
        noPrint: filterType === 'all' ? item.noPrint : false,
      }));

    return {
      ...ResumeData,
      experience,
    };
  };
  const [activeFilter, setActiveFilter] = useState(0);
  const [resumeData, setResumeData] = useState(() => getResumeDataForFilter());
  const getResumeItemKey = (item) =>
    `${item.company}-${item.title}-${item.location}-${String(
      item.dateStart
    )}-${String(item.dateEnd)}`;

  const gaClick = (button) => {
    console.log('awesome resume filter ga click happening');
    ReactGA.event({
      category: 'About Page',
      action: `${button} Button`,
      label: 'Button clicked!',
    });
  };
  const filterResumeItems = (filterType) => {
    gaClick(`Resume - ${filterType} filter`);
    if (filterType === 'education') {
      setActiveFilter(2);
    } else if (filterType === 'development') {
      setActiveFilter(1);
    } else {
      setActiveFilter(0);
    }

    setResumeData(getResumeDataForFilter(filterType));
  };

  const renderExperienceItems = (experienceItems, showAllPrintContent = false) =>
    experienceItems.map((item) => (
      <ResumeItems
        t={item}
        key={getResumeItemKey(item)}
        color={Colors[0]}
        showAllPrintContent={showAllPrintContent}
      />
    ));

  const renderEducationSection = (educationItems, showAllPrintContent = false) => (
    <div className={showAllPrintContent ? '' : noPrint}>
      <h1 className={maskBackground}>Education</h1>
      <ColoredLine color={Colors[1]} />
      {educationItems.map((item) => (
        <ResumeItems
          t={item}
          key={getResumeItemKey(item)}
          color={Colors[2]}
          ed={true}
          showAllPrintContent={showAllPrintContent}
        />
      ))}
    </div>
  );

  const renderSkillSection = (title, color, items, keyField = 'title') => (
    <div className={printResumeSection}>
      <h1 className={maskBackground}>{title}</h1>
      <ColoredLine color={color} />
      <div className={softSkillContainer}>
        {items.map((item) => (
          <span
            key={item[keyField]}
            className={`${softSkillBubble} ${maskBackground}`}
            style={{ border: `1px solid ${color}` }}>
            {item[keyField]}
          </span>
        ))}
      </div>
    </div>
  );

  const renderResumeIntro = (printVariant = false) => (
    <p className={printVariant ? resumeIntroPrint : resumeIntro}>
      {resumeIntroText}
    </p>
  );

  return (
    <div>
      <div className={PRINT_FULL_RESUME ? noPrint : ''}>
        {renderResumeIntro()}
        <div>
          <h1 className={maskBackground} style={{ display: 'inline' }}>
            Experience
            <img
              src='/images/portfolioQR.png'
              alt=''
              className={`${qr} ${printOnly}`}
            />
          </h1>
          <div className={resumeFilterButtons}>
            <MyButton
              text={'All'}
              buttonStyle={`${gStyles.resumeButton} ${smallerButton} ${
                activeFilter === 0 ? activeStyleFilter : magentaButton
              }`}
              functionHandler={filterResumeItems}
              functionParam='all'
            />
            <MyButton
              text={'Dev'}
              functionHandler={filterResumeItems}
              functionParam='development'
              buttonStyle={`${gStyles.resumeButton} ${smallerButton} ${
                activeFilter === 1 ? activeStyleFilter : magentaButton
              }`}
            />
            <MyButton
              text={'Edu'}
              functionHandler={filterResumeItems}
              functionParam='education'
              buttonStyle={`${gStyles.resumeButton} ${smallerButton} ${
                activeFilter === 2 ? activeStyleFilter : magentaButton
              }`}
            />
          </div>
        </div>
        <ColoredLine color={Colors[0]} />
        <div key={activeFilter}>{renderExperienceItems(resumeData.experience)}</div>
        {renderEducationSection(resumeData.education)}
      </div>
      {PRINT_FULL_RESUME ? (
        <div className={printOnly}>
          {renderResumeIntro(true)}
          <h1 className={maskBackground} style={{ display: 'inline' }}>
            Experience
            <img src='/images/portfolioQR.png' alt='' className={qr} />
          </h1>
          <ColoredLine color={Colors[0]} />
          {renderExperienceItems(resumeData.experience, true)}
          {renderEducationSection(ResumeData.education, true)}
          {renderSkillSection('Hard Skills', Colors[2], ResumeData.skills)}
          {renderSkillSection('Soft Skills', Colors[2], ResumeData.softSkills)}
        </div>
      ) : null}
    </div>
  );
}
